import texts from "../assets/texts.json";
import textsEs from "../assets/texts-es.json";
import textsDe from "../assets/texts-de.json";

const useLanguage = (language, path) => {
  const getTexts = (textsObject) => {
    return path.split(".").reduce((acc, part) => acc && acc[part], textsObject);
  };

  switch (language) {
    case "en":
      return getTexts(texts);
    case "de":
      return getTexts(textsDe);
    case "es":
    default:
      return getTexts(textsEs);
  }
};

export default useLanguage;
